export const font = {
  sans: {
    family: 'National2',
    fontDisplay: 'swap',
    weight: {
      regular: 400,
      extrabold: 900,
    },
  },
  serif: {
    family: 'Signifier',
    fontDisplay: 'swap',
    weight: {
      light: 300,
    },
  },
  fallback: {
    family: 'sans-serif',
    fontDisplay: 'swap',
  },
  bravebison: {
    family: 'Bravebison',
    fontDisplay: 'swap',
    weight: {
      extrabold: 900,
    },
  },
}
